import { useRef } from "react";
import { Outlet } from "react-router";
import cx from "classnames";
import { useApplyCostUnitLabel } from "src/business-hooks/useApplyCostUnitLabel";
import { Sidebar } from "src/layout/Sidebar/Sidebar";
import TokenExpiryBanner from "src/layout/TokenExpiryBanner/TokenExpiryBanner";
import { Topbar } from "src/layout/Topbar/Topbar";
import { AppProviders } from "@components/App/components/AppProviders/AppProviders";
import AppToolboxSlot from "../AppToolboxSlot/AppToolboxSlot";
import PersistedSearchParamsSync from "../PersistedSearchParamsSync/PersistedSearchParamsSync";

export const AppMainWrapper = () => {
  const mainPanelRef = useRef<HTMLDivElement>(null);

  useApplyCostUnitLabel();

  return (
    <AppProviders>
      <div className="app flex flex-col h-screen">
        <TokenExpiryBanner />
        <Topbar />
        <section className="flex flex-1">
          <Sidebar />
          <main
            ref={mainPanelRef}
            className={cx(
              "flex-1 min-w-0 min-h-0 p-page pb-0 relative",
              "in-[.panel-resizing]:pointer-events-none",
              'has-[+_*:not([class~="hidden"])]:pr-0'
            )}
            data-test-id="main-content-holder"
          >
            <Outlet />
          </main>
          <AppToolboxSlot mainPanelRef={mainPanelRef} />
        </section>
      </div>
      {/* After the page tree so this effect runs after Tabs cleanup; otherwise
          cleanup's setSearchParams wins and drops the activation fill. */}
      <PersistedSearchParamsSync />
    </AppProviders>
  );
};
